module.exports = __webpack_public_path__ + "img/Receptors-Impact identification.7df96c5a.svg";